import { $t } from "@/plugins/i18n";
import { home } from "@/router/enums";
const { VITE_HIDE_HOME } = import.meta.env;
const Layout = () => import("@/layout/index.vue");
import homeIcon from "@/assets/svg/home.svg?component";
export default {
  path: "/",
  name: "TestLayout",
  component: Layout,
  redirect: "/test",
  meta: {
    icon: homeIcon,
    title: "测试",
    rank: home
  },
  children: [
    {
      path: "/test",
      name: "Test",
      component: () => import("@/views/test/index.vue"),
      meta: {
        title: "测试",
        showLink: false
      }
    }
  ]
} satisfies RouteConfigsTable;
